module.exports = __webpack_public_path__ + "static/media/hakim_real.57c7c278.jpg";